import React from "react";

function YurtSVG({width}) {
  return (
    <div>
      <svg
        width={width}
        fill="#667666"
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 274.29 274.53"
      >
        <path
          d="M1686,445h15v66.8c1,0.46,3,.89,4,1.3V445h34v73.68c1,0.05,3,.08,4,0.09V445h50v65a17.91,17.91,0,0,1,4-1.65V445h68.67q1-1.5,1.85-3h-2.16l-27.91-92H1842l37,57.08c0.1-.52.2-1,0.29-1.54L1843.22,350h2.61l35.47,37c0-.42,0-0.81,0-1.23L1847.11,350h3l31.21,26.32c0-.4,0-0.77,0-1.17L1851.51,350h1.63l27.74,19.41c0-.3-0.05-0.57-0.08-0.87L1854.24,350h1.34l24.92,15.72a137.18,137.18,0,1,0-194.5,140V445Zm-0.23-3L1813,350h1.37L1705,442h-19.27Zm22,0,108.42-92h2.24l-83.28,92h-27.38Zm30.23,0,82.09-92h4L1775,442h-37Zm40.21,0,47.13-92h4.37l-12.35,92h-39.15Zm84.33,0h-42.42l11-92h5.2Zm-29.68-108.65c12.76,0,22.76,6.65,22.76,14.65h-45.52C1810.07,340,1820.06,333.35,1832.83,333.35Zm-130.65-39a28.36,28.36,0,1,1-28.36,28.35A28.35,28.35,0,0,1,1702.18,294.36ZM1665.5,440.58L1810.07,350h1.21l-128.7,92H1665.9A0.77,0.77,0,0,1,1665.5,440.58Z"
          transform="translate(-1607.06 -244.24)"
        />
        <path
          d="M1811,465v36.49A142,142,0,0,0,1853.21,465H1811Z"
          transform="translate(-1607.06 -244.24)"
        />
      </svg>
    </div>
  );
}

export default YurtSVG;
